import { SvgIcon, SvgIconProps } from '@mui/material';

export const ProviderIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M21 24.5C21 22.6435 20.2625 20.863 18.9497 19.5503C17.637 18.2375 15.8565 17.5 14 17.5C12.1435 17.5 10.363 18.2375 9.05025 19.5503C7.7375 20.863 7 22.6435 7 24.5'
          stroke='currentColor'
          strokeWidth='2.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.9987 17.5013C16.576 17.5013 18.6654 15.412 18.6654 12.8346C18.6654 10.2573 16.576 8.16797 13.9987 8.16797C11.4214 8.16797 9.33203 10.2573 9.33203 12.8346C9.33203 15.412 11.4214 17.5013 13.9987 17.5013Z'
          stroke='currentColor'
          strokeWidth='2.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M22.1667 3.5H5.83333C4.54467 3.5 3.5 4.54467 3.5 5.83333V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V5.83333C24.5 4.54467 23.4553 3.5 22.1667 3.5Z'
          stroke='currentColor'
          strokeWidth='2.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
